import React, { createContext, useContext } from 'react';

export const EOAFContext = createContext({
  structureTree: [],
  loading: false,
  error: null,
  refetch: () => {},
});

export const useEOAFContext = () => {
  const context = useContext(EOAFContext);
  return context ?? {
    structureTree: [],
    loading: false,
    error: null,
    refetch: () => {},
  };
};
